import DashStatCard from '../../components/ui/DashStatCard'
import LineChart from '../../components/ui/LineChart'
import DashIcon from '../../components/ui/DashIcon'

const months = ['Jan','Fév','Mar','Avr','Mai','Juin','Juil','Aoû','Sep','Oct','Nov','Déc']
const rev     = [4200,5100,5800,6400,7200,8100,9200,10100,11200,12400,13200,14800]

export default function ExpediteurRapports() {
  return (
    <>
      <div className="page-head">
        <div className="ph-titles">
          <h1>Rapports</h1>
          <p>Analyses détaillées de votre activité.</p>
        </div>
        <div className="ph-actions">
          <div className="seg">
            <button>Semaine</button>
            <button>Mois</button>
            <button className="is-active">Année</button>
          </div>
          <button className="btn btn-ghost"><DashIcon name="download" size={14} /> Exporter</button>
        </div>
      </div>

      <div className="stat-grid stat-grid-4" style={{ marginBottom: 18 }}>
        <DashStatCard label="Revenu total"     value="98,720 DT" trend="+24% vs an dernier" icon="wallet" accent="green" />
        <DashStatCard label="Colis envoyés"    value="2,844"     trend="+312 ce trimestre"  icon="package" />
        <DashStatCard label="Taux livraison"   value="96.4%"     trend="Top 3%"              icon="check" />
        <DashStatCard label="Nouveaux clients" value="84"        trend="+18 ce mois"         icon="users" />
      </div>

      <div className="card chart-card">
        <div className="chart-head">
          <div>
            <div style={{ fontSize: '.78rem', color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '.08em', fontWeight: 600 }}>
              Revenu mensuel
            </div>
            <div style={{ fontFamily: 'Space Grotesk', fontSize: '1.5rem', fontWeight: 700, color: 'var(--navy-900)', marginTop: 2 }}>
              98,720 DT
            </div>
          </div>
        </div>
        <div className="chart-body" style={{ height: 320 }}>
          <LineChart series={[{ data: rev }]} labels={months} height={320} />
        </div>
      </div>
    </>
  )
}
